import React from "react";

export default function EventDate({ start, end, timeZone }) {
  return (
    <>
      <span className="font-bold">{start.date}</span>
      {start.time ? (
        <>
          <span className="font-normal">, {start.time}</span>{" "}
        </>
      ) : null}
      {end.date && start.date !== end.date ? (
        <span className="font-normal">
          {" "}
          - <span className="font-bold">{end.date}</span>{" "}
          {end.time && (
            <>
              <span className="font-normal">, {end.time}</span>{" "}
            </>
          )}
        </span>
      ) : end.time ? (
        <>
          <span className="font-normal">
            {" "}
            - <span>{end.time}</span>
          </span>{" "}
        </>
      ) : null}
      <span className="font-normal">{timeZone}</span>
    </>
  );
}
